export default __webpack_public_path__ + "static/media/linked_in2.76a6d58d.svg";